export enum EventActionType {
    PageSelected = 'page selected',
    ReportLoaded = 'report loaded',
    ReportRendered = 'report rendered',
    ButtonClicked = 'button clicked',
    SelectionChanged = 'selection changed',
    VisualClicked = 'visual clicked',
    DataSelected = 'data selected',
    Click = 'click',
    Error = 'error',
}
